import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { Vehicle, vehicleSchema } from '../schemas/vehicle.schema';

/**
 * Imports an array of new Vehicles
 * @param vehicles The Vehicles being imported
 * @returns Data object containing the newly imported Vehicles
 */
export function postVehiclesImport(
  this: unknown,
  vehicles: Partial<Vehicle>[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).vehiclesImportUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(vehicles),
      })
    )
  ).pipe(
    selectData(
      z.array(
        z.object({
          item: vehicleSchema.omit({ modifiedOn: true }).extend({
            groups: z
              .array(z.object({ vehicleGroupName: z.string() }))
              .optional()
              .nullable(),
          }),
          importResult: z.string(),
          validationResult: z.string(),
        })
      )
    )
  );
}
